
<div class="page legacy-page overlayed" id="record-def-new-page">
    <div class="action-bar dark-bg">
        <div class="title no-margin">Crea un nuevo Formulario</div>
        <div class="actions-set">
            <div class="actions-set">
                <a class="action-btn done SaveBtn" href="#"></a>
                |
                <a class="action-btn delete" href="#"></a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
        </div>
    </div>
    <div class="page-overlay"></div>
    <div class="content">
        <div class="container legacy-container">

            <div class="section" id="nuevo-formulario">
                <form class="legacy-form" id="new-record-def-form">
                                        
                    <a class="action-btn CancelBtn" icon="cancel" href="#"></a>
                    
                    <h2>Nuevo formulario</h2>

                    <ul>
                        <li></li>

                        <li class="StringCtrl required" property="title">
                            <label>Nombre</label>
                            <input type="text" size=32 placeholder=""/>
                            <p class="hint">
                                Ingresa aquí un nombre descriptivo para este nuevo <b>Formulario</b>. 
                                Este campo es necesario.
                            </p>
                        </li>

                        <li class="StringCtrl" property="alias">
                            <label>Alias</label>
                            <input type="text" size=22/>
                            <p class="hint">
                                Se usará este alias para referirse al formulario.
                            </p>
                        </li>
        
                        <li class="StringCtrl" property="version">
                            <label>Version</label>
                            <input type="text" size=4/>
                            <p class="hint">
                                Numero de versión con que arranca este formulario.
                            </p>
                        </li>

                        <li class="TextCtrl" property="descr">
                            <label>Descripción</label>
                            <textarea rows="1"></textarea>
                            <p class="hint">Breve descripción del formulario.</p>
                        </li>
                    </ul>

                    <p class="form-buttons">
                        <button class="accept CreateBtn">AGREGAR AHORA</button>
                    </p>

                </form>
            </div> <!-- nuevo-formulario -->

        </div>
    </div>
</div>


<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#record-def-new-page").RecordDefNewPage("#nuevo-formulario");
  console.log("DONE: installed RecordDefNewPage to hash '#nuevo-formulario'")
})
</script>
